import {remoteStream} from '@stream'

export default function useRemoteStream () {
  return {
    video: remoteStream.video,
    audio: remoteStream.audio
  }
}
